export const getDocumentCookie = () => {
  return document.cookie
}

export const setDocumentCookie = cookie => {
  document.cookie = cookie
}

export const get = name => {
  const cookie = getDocumentCookie()
  const re = new RegExp(`${name}=(.[^;]+)?`)
  const match = cookie.match(re)
  return match && match.length && match[1]
}

export const set = (name = '', value = '', options = {}) => {
  const params = [`${name}=${value}`]

  if (options.expires) {
    params.push(`expires=${options.expires}`)
  }

  if (options.path) {
    params.push(`path=${options.path}`)
  }

  if (options.domain) {
    params.push(`domain=${options.domain}`)
  }

  setDocumentCookie(params.join(';'))
}

export const remove = name => {
  document.cookie = `${name}=path=/expires=Thu, 01-Jan-70 00:00:01 GMT;`
}
